import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Table, IconButton, TableHead, TableRow, TableCell } from 'react-toolbox'
import CSSModules from 'react-css-modules'
import _ from 'lodash'
import * as R from 'ramda'

import AddButton from 'components/custom/AddButton/index'

import styles from './styles.scss'

class ConfigTable extends Component {
  static propTypes = {
    configSource: PropTypes.array.isRequired,
    tableHeadContent: PropTypes.object.isRequired,
    filters: PropTypes.object.isRequired,
    onDeletePart: PropTypes.func.isRequired,
    initFilters: PropTypes.func.isRequired,
    deletable: PropTypes.bool.isRequired,

    btnText: PropTypes.string,
    createAddBtn: PropTypes.bool,
    configKeys: PropTypes.array,
    onTogglePopup: PropTypes.func,
    onUpdateCurConfig: PropTypes.func,
  }

  static defaultProps = {
    deletable: false,
  }

  deletePart(partId) {
    return () => {
      this.props.onDeletePart(partId)
    }
  }

  getTableHeadContent = () => {
    return this.props.deletable
      ? { ...this.props.tableHeadContent, delete: (<TableCell key={4}><IconButton /></TableCell>) }
      : { ...this.props.tableHeadContent }
  }

  getPartSource = () => {
    return this.props.configSource.map((config, index) => {

      // Notebook CPU requires arrayIndex to delete item. Memory Parts Library does not use index but requires partID 
      // from PartsLibrary to uniquely identify and delete correct part. 

      const deleteIdorIndex = _.has(config, 'id') ? config.id : index

      return this.props.deletable
        ? { ...config, delete: <IconButton icon='delete' onClick={this.deletePart(deleteIdorIndex)} primary /> }
        : config
    })
  }

  getTableHead = (tableHeadContent) => (
    <TableHead>
      {R.map((key) => tableHeadContent[key], R.keys(tableHeadContent))}
    </TableHead>
  )

  getViewTableRows = (source, tableHeadContent) => {
    const mapIndexed = R.addIndex(R.map);
    return (
      mapIndexed((rowContent, idx) => (
        <TableRow key={'row_' + idx}>
          {mapIndexed((key, idx) => (
            <TableCell key={'cell_' + idx}>{(rowContent && rowContent[key]) ? rowContent[key] : ''}</TableCell>
          ), R.keys(tableHeadContent))}
          {this.props.createEditBtn ? 
            <IconButton class={styles.editButton} icon='edit' onClick={this.props.onEdit} />
            : ''
          }
        </TableRow>
      ), source)
    )
  }



  render() {
    const {
      configSource,
      btnText,
      createAddBtn,
      configKeys,
      filters,
      initFilters,
      onTogglePopup,
      onUpdateCurConfig,
      setIsAddPart,
    } = this.props

    const tableHeadContent = this.getTableHeadContent();
    const tableSource = this.getPartSource();

    // Create add button for the configuration if needed
    if (createAddBtn && tableHeadContent) {
      const firstField = R.keys(tableHeadContent)[0];
      tableSource.push({
        [firstField]: <AddButton
          addConfig={_.pick(configSource[0], configKeys)}
          btnText={btnText}
          filters={filters}
          initFilters={initFilters}
          onTogglePopup={onTogglePopup}
          onUpdateCurConfig={onUpdateCurConfig}
          setIsAddPart={setIsAddPart}
        />
      })
    }

    return (
      <Table theme={styles} selectable={false}>
        {this.getTableHead(tableHeadContent)}
        {this.getViewTableRows(tableSource, tableHeadContent)}
      </Table>
    )
  }
}

export default CSSModules(ConfigTable, styles)
